import axios from 'axios'
import S3Api from '@/api/s3'
const server = process.env.VUE_APP_API_URL || ''
const api = `${server}/api/customartist/artwork`

const loadArtworks = () => {
  return axios.get(api)
}
const uploadArtworkImage = async (data) => {
  const config = {
      onUploadProgress: progressEvent => console.log(progressEvent.loaded)
  }
  const postData = await S3Api.getS3PresignedPost(`${data.path}/${data.name}`, "S3_CUSTOMER_UPLOADS_BUCKET")
  const formData = new FormData()
  formData.append("file", data.file, data.name)
  return axios.put(
    postData.data,
    data.file,
    {
      onUploadProgress: progressEvent => console.log(progressEvent.loaded),
      headers: {
        'Content-Type': 'image/jpeg'
      }
    }
  )
}


export default {
  loadArtworks,
  uploadArtworkImage
}
